import ConfirmActionModal from './ConfirmActionModal';
import { questionService } from 'services/api';
import styles from './ConfirmarFinalizarModal.module.css';

// Confirmación antes de FINALIZAR una asamblea (R219: «Finalizar» siempre pide confirmar, para no hacerlo con un clic sin querer).
// · Con votaciones abiertas: aviso de que, al finalizar, cada una se cierra con los presentes de ESE momento (utils/finalizarAsamblea.js): si ya se
//   fueron todos, el acta las muestra con 0 % de presentes. Lo recomendable es cerrarlas antes, con la sala llena.
// · Sin votaciones abiertas: confirmación simple que explica que el acta queda fija.

// Votaciones abiertas de una asamblea. Si no se pueden consultar, devuelve [] para NO bloquear la
// finalización (el aviso es una ayuda, no una compuerta).
export async function votacionesAbiertas(assemblyId) {
  try {
    const r = await questionService.getAll({ assembly_id: assemblyId });
    return (Array.isArray(r.data) ? r.data : []).filter(q => q.active);
  } catch { return []; }
}

const MAX_LISTADAS = 5;

export default function ConfirmarFinalizarModal({ abiertas, asamblea, onClose, onConfirm, loading }) {
  const n = abiertas.length;
  if (n === 0) {
    const numero = asamblea?.number_assembly ?? asamblea?.id;
    return (
      <ConfirmActionModal
        title={`¿Finalizar la asamblea${numero != null ? ` #${numero}` : ''}?`}
        onClose={onClose} onConfirm={onConfirm} loading={loading}
        confirmLabel="Finalizar" confirmIcon="fa-stop" maxWidth={520}>
        {asamblea?.property?.name && <p className={styles.subtitulo}>{asamblea.property.name}</p>}
        <p className={styles.texto}>
          Al finalizar, <strong>el acta queda fija</strong>: ya no se podrán cambiar la asistencia, los poderes, las preguntas ni las elecciones.
          Si más adelante hay que corregir algo, se puede <strong>reiniciar</strong> la asamblea.
        </p>
      </ConfirmActionModal>
    );
  }
  return (
    <ConfirmActionModal
      title={n === 1 ? 'Hay una votación abierta' : `Hay ${n} votaciones abiertas`}
      onClose={onClose} onConfirm={onConfirm} loading={loading}
      confirmLabel="Cerrar y finalizar" confirmIcon="fa-stop" maxWidth={520}>
      <p className={styles.subtitulo}>{n === 1 ? 'Sigue abierta:' : 'Siguen abiertas:'}</p>
      <ul className={styles.lista}>
        {abiertas.slice(0, MAX_LISTADAS).map(q => <li key={q.id}>{q.question_text}</li>)}
        {n > MAX_LISTADAS && <li>… y {n - MAX_LISTADAS} más</li>}
      </ul>
      <p className={styles.texto}>
        Si finalizas ahora, {n === 1 ? 'se cerrará' : 'se cerrarán'} con las personas que estén presentes <strong>en este momento</strong>.
        Si ya se fueron, el acta mostrará {n === 1 ? 'esa votación' : 'esas votaciones'} con 0&nbsp;% de presentes.
        Lo recomendable es cancelar, cerrar {n === 1 ? 'la votación' : 'cada votación'} desde <strong>Preguntas</strong> mientras los asistentes siguen en la sala, y después finalizar.
      </p>
    </ConfirmActionModal>
  );
}
